var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/tick-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6630132,3.7795577 C16.1674857,4.0043375 16.3942214,4.59551328 16.1694416,5.09998576 C15.9446618,5.60445825 15.353486,5.83119396 14.8490136,5.60641416 C12.0173215,4.34468593 8.69301288,5.09576952 6.67883185,7.4523587 C4.66465083,9.80894788 4.44040877,13.209664 6.12771025,15.8103277 C7.81501173,18.4109913 11.0119135,19.5920813 13.984763,18.7131025 C16.9576125,17.8341238 18.9982276,15.1044636 18.9999942,12.0049653 L18.9999942,11.2689674 C18.9999942,10.7166826 19.4477153,10.2689674 19.9999942,10.2689674 C20.5522847,10.2689674 20.9999942,10.7166826 20.9999942,11.2689674 L20.9999942,12.0055371 C20.9977209,15.9913443 18.374071,19.5009099 14.5518332,20.6310263 C10.7295954,21.7611426 6.61929011,20.2425973 4.44990094,16.8988845 C2.28051177,13.5551717 2.56882319,9.18281922 5.15848636,6.15291667 C7.74814954,3.12301412 12.0222637,2.15733452 15.6630132,3.7795577 Z M20.7067533,4.89752328 C21.0974727,5.28785236 21.0977891,5.92101726 20.7074601,6.31173667 L12.7074827,14.3197141 C12.3170156,14.7105715 11.6835781,14.7107298 11.2929158,14.3200675 L8.89292258,11.9200743 C8.50239829,11.52955 8.50239829,10.896385 8.89292258,10.5058607 C9.28344687,10.1153364 9.91661185,10.1153364 10.3071361,10.5058607 L12.0000294,12.1979834 L19.2925399,4.89823004 C19.682869,4.50751063 20.3160339,4.5071942 20.7067533,4.89752328 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/tick-white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/success",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickWhite);
export default __webpack_public_path__ + "static/media/tick-white.941c468fa66fc09ec6379b125ef8e5c4.svg";
export { ForwardRef as ReactComponent };